// extracted by mini-css-extract-plugin
export default {"title":"ContactInfoSettingsCard_title__uPzcC"};